import React from 'react'
import { Row, Col } from 'antd'
import PartDetailForm from '$components/PartDetailForm'
import Part3dFileUpload from '$components/FileUpload/Part3dFileUpload'

const ExpandedRow = React.memo(
  ({ record }) => (
    <Row gutter={[20, 0]}>
      <Col span={6}>
        <Part3dFileUpload record={record} />
      </Col>
      <Col span={18}>
        <PartDetailForm record={record} showEditDates={true} />
      </Col>
    </Row>
  ),
  (prevProps, nextProps) => {
    return (
      prevProps.record.id === nextProps.record.id &&
      prevProps.record.updated_at === nextProps.record.updated_at
    )
  },
)

ExpandedRow.displayName = 'PartsMasterDataExpandedRow'

export default ExpandedRow
